import { useTranslation } from "react-i18next";
import { rankings } from "@/mocks/highlights";

export default function RankingsSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-20 md:py-28 bg-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <div className="text-primary-600 text-xs md:text-sm tracking-[0.3em] font-medium mb-3">
            {t("rankings.label")}
          </div>
          <h2 className="font-heading font-bold text-foreground-950 text-3xl md:text-5xl leading-tight">
            {t("rankings.title")}
          </h2>
          <p className="text-foreground-600 mt-4 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            {t("rankings.description")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {rankings.map((r) => (
            <article
              key={r.id}
              className="group relative overflow-hidden rounded-lg bg-background-50 border border-background-300/60 hover:border-primary-400 transition-colors"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={r.image}
                  alt={r.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute top-4 left-4 px-3 py-1 rounded-md bg-primary-700 text-background-50 text-xs font-medium tracking-widest">
                  {r.year}
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-heading font-bold text-foreground-950 text-lg md:text-xl leading-tight mb-3">
                  {r.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">{r.desc}</p>
                <a
                  href={r.link}
                  className="inline-flex items-center gap-2 text-primary-700 group-hover:text-primary-500 text-sm font-medium tracking-wider cursor-pointer whitespace-nowrap"
                >
                  {t("rankings.viewFull")}
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}